import { pieveLogoPaths } from './pieveLogo/pieveLogoPaths.js';

/** The standalone Pieve symbol, drawn in the current text color. */
const PieveSymbol = ({ size = 24, label = 'Pieve' }) => {
  const { symbolStroke, symbolStrokeWidth, symbolCore } = pieveLogoPaths;
  return (
    <svg className="comp-pieve-symbol" width={size} height={size} viewBox="0 0 32 32" role="img" aria-label={label}>
      <path d={symbolStroke} fill="none" stroke="currentColor" strokeWidth={symbolStrokeWidth} strokeLinecap="round" />
      <circle cx={symbolCore.cx} cy={symbolCore.cy} r={symbolCore.r} fill="currentColor" />
    </svg>
  );
};

export default PieveSymbol;
